import { SCHUFA_STATE } from 'cpool-constants';
import { z } from 'zod';

import {
    schemaConsorsSchufaResponseEntry,
    schemaSchufaResponsePosition,
    schemaSchufaResponseSchufaKopf,
} from './ConsorsSchufaResponse';

export const schemaMappedPosition = z.object({
    amount: schemaSchufaResponsePosition.shape.creditAmount,
    code: schemaSchufaResponsePosition.shape.code,
    date: schemaSchufaResponsePosition.shape.date,
    internalLoan: schemaSchufaResponsePosition.shape.internalLoan,
    period: schemaSchufaResponsePosition.shape.installmentNumber,
    rate: schemaSchufaResponsePosition.shape.calculatedInstallment,
    rateType: schemaSchufaResponsePosition.shape.installmentType,
    remainingAmount: schemaSchufaResponsePosition.shape.outstandingAmount,
    reportingAmount: schemaSchufaResponsePosition.shape.meldebetrag,
    type: schemaSchufaResponsePosition.shape.creditType,
});

export type SchemaMappedPosition = z.infer<typeof schemaMappedPosition>;

export const schemaMappedSchufaResponse = z.object({
    applicantData: schemaSchufaResponseSchufaKopf.nullish(),
    consorsResponse: schemaConsorsSchufaResponseEntry.nullish(),
    decision: schemaConsorsSchufaResponseEntry.shape.decision.nullish(),
    duplicatedRequest: z.boolean().default(false),
    error: z.string().nullish(),
    identifier: schemaConsorsSchufaResponseEntry.shape.identifier.nullable(),
    positions: z.array(schemaMappedPosition).nullish(),
    score: z.number().nullable(),
    state: z.nativeEnum(SCHUFA_STATE).nullish(),
    status: schemaConsorsSchufaResponseEntry.shape.status.nullish(),
});

export type SchemaMappedSchufaResponse = z.infer<typeof schemaMappedSchufaResponse>;
